import React, { Dispatch, SetStateAction } from 'react'

import { PageData } from '../api/Pagination/Types'

interface TableStateContextProps {
  skipCount?: boolean
  meta?: PageData<unknown>
}

export type TableStateContextData = TableStateContextProps | null
export type TableStateContextAction = Dispatch<SetStateAction<TableStateContextData>>
export type TableStateContextType = [TableStateContextData, TableStateContextAction]
export type TableStateData = {
  tableData: TableStateContextData
  setTableData: TableStateContextAction
}
export const TableStateContext = React.createContext<TableStateContextType>([null, () => {}])
